

























import { defineComponent } from '@nuxtjs/composition-api';

import useAppRoute from '~/compositions/useAppRoute';

/**
 * コンポーネントの始まり
 */
export default defineComponent({
  // 現在 ドメインルート「/」が何故か、Googleに英語でインデックスされている。
  // ドメインルートは/app/launchにリダイレクトしているが、
  // もしかしたらこのリダイレクトの絡みで英語がインデックスされている可能性があるので、
  // 一旦リダイレクト前の「/」を処理する、このページで無理やり全て英語のタイトルと説明を返却してみる。
  // これをリリースして１週間ほど様子を見てインデックスに変化があるかどうかを確認する。
  // (※リリース日 2020/12/22 )
  /**
   * HTMLの<head>区画に出力されるメタ情報
   * (※ TODO: 本来は nuxt/composition-api の useMeta() を使用したいが、今は仕方なしにこれを使っておく
   *          キメラ状態だが、graphqlのcomposableの中尾vule/composition-apiへの参照問題が解消されるか、捨てたら直す
   * )
   */
  // head() {
  //   // SEO対策のためのオブジェクトを取り出す
  //   const i18nSeo = this.$nuxtI18nSeo();

  //   return {
  //     // これが実際に出力される title になる → こんな感じ → 就職活動記録｜【キャリアマップ】
  //     titleTemplate: '%s｜【' + this.$t('head.meta.app_name') + '】',

  //     // どのページでも通用するようなタイトルをとりあえず入れとく
  //     title: this.$t('head.meta.title'),

  //     meta: [
  //       // どのページでも通用するような【Description】を入れておく
  //       {
  //         hid: 'description',
  //         name: 'description',
  //         content: this.$t('head.meta.description'),
  //       },
  //       // 多言語化部分の meta 情報を展開
  //       ...i18nSeo.meta,
  //     ],
  //   };
  // },

  /**
   * このコンポーネントの初期化処理
   * (第一引数は props, 第二引数は SetupContext)
   */
  setup(_props, context) {
    const { URLs, redirect } = useAppRoute();

    // ドメイン直下にアクセスされたときはIPhoneやAndroidの初期表示と同じ場所に飛ばす
    redirect(context.root.localePath(URLs.app_launch));

    return {};
  },
});
